import React from "react";
import { Button } from "react-bootstrap";
import { Link, useHistory, useParams, useLocation } from "react-router-dom";
import Posts from "../Components/Posts";
import TryLogin from "../Components/TryLogin";
import UserContext from "../UserContext";
import Logged from "../Components/Profile.jsx";
import { loadPost } from "../utils/functions";
import SEO from "../Components/SEO";
import SidebarNav from "../Components/navigation/SidebarNav";

function SinglePost() {
  const [post, setpost] = React.useState();
  const { user, posts } = React.useContext(UserContext);
  const { id } = useParams();

  React.useEffect(() => {
    async function loaddata() {
      let tempPost = posts.find((item) => item._id === id);
      if (!tempPost) {
        let response = await loadPost(user.token, id);
        let myLike = response.arrayOfFires?.find((item) => {
          return item === user.info?._id;
        });
        tempPost = { ...response, liked: myLike ? true : false };
      }
      setpost(tempPost);
    }
    loaddata();
    // eslint-disable-next-line
  }, [id, posts, user]);
  const history = useHistory();
  const location = useLocation();
  if (!user.token) {
    history.push(`/login?redirect_url=${location.pathname + location.search}`);
  }
  return (
    <>
      <SEO
        title={`${post?.author?.username}'s post`}
        description={post?.description}
      ></SEO>
      <div className="flex justify-center w-full">
      <div className="px-2 grid grid-cols-1 lg:grid-cols-11 lg:w-3/4 lg:gap-10">
      <div className="lg:col-span-6 lg:grid grid-cols-7">
            <div className="top-0 sticky col-span-1 lg:h-screen">
              <div className="hidden lg:block">
              <SidebarNav />
              </div>
            </div>
            <div className="col-span-6">
            {post ? (
              <Posts data={post} showFewComments={false} />
            ) : (
              <Posts data={{}} showFewComments={false} />
            )}
            <Link to="/" className="readMore__link">
              <Button className="mb-3 bg-fire hover:opacity-80 text-white rounded px-3 ">
                Return to Home
              </Button>
            </Link>
          </div>
          </div>
          <div className="lg:col-span-5">
            {user.token ? <Logged /> : <TryLogin />}
          </div>
        </div>
      </div>
    </>
  );
}

export default SinglePost;